import { render, staticRenderFns } from "./tertiary.vue?vue&type=template&id=381af91e&"
import script from "./tertiary.vue?vue&type=script&lang=js&"
export * from "./tertiary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports